import { useNavigate } from 'react-router-dom';
import { FiXCircle, FiArrowLeft, FiHelpCircle } from 'react-icons/fi';

const PaymentCancel = () => {
  const navigate = useNavigate();

  const handleTryAgain = () => {
    // Limpiar datos de sesión y volver a la landing
    sessionStorage.removeItem('pendingRegistration');
    navigate('/#pricing');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8">
        <div className="text-center">
          {/* Icon */}
          <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <FiXCircle className="w-10 h-10 text-orange-600" />
          </div>

          {/* Title */}
          <h2 className="text-2xl font-bold text-gray-900 mb-3">
            Pago Cancelado
          </h2>

          {/* Message */}
          <p className="text-gray-600 mb-6">
            Has cancelado el proceso de pago. No se ha realizado ningún cargo a tu cuenta.
          </p>

          {/* Info Box */}
          <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6 text-left">
            <div className="flex items-start gap-3">
              <FiHelpCircle className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
              <div className="text-sm text-blue-900">
                <p className="font-semibold mb-1">¿Necesitas ayuda?</p>
                <p className="text-blue-700">
                  Si tuviste algún problema con el proceso de pago o tienes preguntas,
                  no dudes en contactarnos.
                </p>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="space-y-3">
            <button
              onClick={handleTryAgain}
              className="w-full px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all font-semibold flex items-center justify-center gap-2"
            >
              <FiArrowLeft className="w-5 h-5" />
              Volver a Intentar
            </button>

            <button
              onClick={() => navigate('/')}
              className="w-full px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Volver al Inicio
            </button>

            <button
              onClick={() => window.location.href = 'mailto:info@teonila.com'}
              className="w-full px-6 py-3 text-blue-600 hover:text-blue-700 transition-colors text-sm"
            >
              Contactar con Soporte
            </button>
          </div>

          {/* Additional Info */}
          <div className="mt-6 pt-6 border-t border-gray-200">
            <p className="text-xs text-gray-500">
              ¿Tienes dudas sobre los planes o necesitas más información?<br />
              Escríbenos a{' '}
              <a
                href="mailto:info@teonila.com"
                className="text-blue-600 hover:text-blue-700 underline"
              >
                info@teonila.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
